// @flow
import { setPartialUpdateDefaultSettings }                  from 'fg-frontend/src/partialUpdate/PartialUpdateSettings';
import { partialUpdateConnectDatasetListeners }             from 'fg-frontend/src/partialUpdate/eventsFromDOMDatasetsRegister';
import partialUpdateConnectLinksListeners                   from 'fg-frontend/src/partialUpdate/connectLinksListeners';
import partialUpdateConnectFormsSubmitListeners             from 'fg-frontend/src/partialUpdate/connectFormsSubmitListeners';
import partialUpdateConnectHistory                          from 'fg-frontend/src/partialUpdate/connectHistory';
import { execute }                                          from 'fg-frontend/src/partialUpdate/partialUpdate';
import { onChangeXHRQueue as CursorSpinnerOnChangeHandler } from 'fg-frontend/src/components/CursorSpinner';

import 'fg-frontend/plugins/jquery.simple-collapse';
import $                                                    from 'jquery';

// nastavení defaultních vlastností partial updatu
setPartialUpdateDefaultSettings({
  onChangeXHRQueue: CursorSpinnerOnChangeHandler,
  // využívá se pro manipulaci s historií
  // je potřeba mít na všech stránkách jsPartialUpdate s id,
  // kde je nastaveno <partialUpdateAlterHistory>true</partialUpdateAlterHistory>
  globalTarget:     'dynamicArea',
  suppressRedirect: true,
});

document.addEventListener('partialUpdateComplete', ({ detail: { settings, hasError, newAccessibleTarget } }) => {
  const {
    type,
    url,
    focusFirstInput,
    target,
  } = settings;

  // zafocusovani do prvnihu inputu
  if (focusFirstInput && target) {
    const firstInput = document.getElementById(target).querySelector('input[type=text], textarea');
    if (firstInput) {
      firstInput.focus();
    }
  }

  // po jakémkoliv přihlášení přes partial update se zaktualizují widgety související s přihlášením
  if (type === 'POST' && !hasError && url.startsWith(`/qf/${ window.projectConfig.lang }/ramjet/performLogin`)) {
    const includeTargets = [
      'userMenu',
      'userLists',
    ].filter((targetId) => document.getElementById(targetId) != null);
    const locationTargets = [
      'partialUpdateContainer',
    ].filter((targetId) => document.getElementById(targetId) != null);

    // include widgety
    if (includeTargets.length > 0) {
      execute({
        url:    `/qf/${ window.projectConfig.lang }/ramjet/include`,
        target: includeTargets,
      });
    }
    // PU obsah stranky
    if (locationTargets.length > 0) {
      execute({
        url:    location.href,
        target: locationTargets,
      });
    }
  }
});

// osetreni fullPageRedirect stranek z pohledu window.history - odkomentujte, pokud NEJSOU zapnute turbolinks
/*document.addEventListener('beforeFullPageRedirect', (event) => {
  event.preventDefault();
  history.replaceState( {} , '', event.detail.location );
  window.location = event.detail.location;
});*/

partialUpdateConnectDatasetListeners([ 'slideStop' ]);
partialUpdateConnectFormsSubmitListeners();
partialUpdateConnectLinksListeners({
  alterHistory: true,
});
partialUpdateConnectHistory();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configurePartialUpdate.js